<template>
  <v-container
    fill-height
    fluid
    grid-list-xl
  >
    <v-layout
      justify-center
      wrap
    >
      <v-flex
        md12
      >
        <div>
          <material-card
            color="general"
            title="Customer Data"
            text="List of Customer Contact Person"
          >
            <v-spacer/>
            <v-text-field
              v-model="search"
              prepend-icon="search"
              label="Search"
              placeholder="Search by Name/Company"
              clearable
              single-line
              hide-details/>
            <v-dialog
              v-model="dialog"
              persistent
              max-width="720px">
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="hasPermission('MA_MD_CUSTOMER_READ') === true"
                  :dark="hasPermission('MA_MD_CUSTOMER_READ') === false"
                  color="general"
                  class="mb-2 ml-1 mr-1"
                  v-on="on">New
                </v-btn>
              </template>
              <v-form
                id="form-vue"
                ref="form"
                v-model="valid"
                :lazy-validation="lazy"
              >
                <v-card>
                  <v-card-text>
                    <v-container grid-list-md >
                      <v-layout wrap>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.name"
                            :rules="[rules.required,rules.max50chars]"
                            label="Name *"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.email"
                            :rules="[rules.email]"
                            label="Email"/>
                        </v-flex>
                        <v-flex
                            xs12
                            sm6
                            md4>
                          <v-text-field
                              v-model="editedItem.position"
                              label="Position"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md4>
                          <v-text-field
                            v-model="editedItem.mobilePhone"
                            :rules="[rules.number,rules.max50chars]"
                            label="Mobile Phone"/>
                        </v-flex>
                        <v-flex
                          xs12
                          sm6
                          md6>
                          <v-autocomplete
                            v-model="editedItem.company"
                            :items="companies"
                            :rules="[rules.requiredCompany]"
                            :search-input.sync="searchCompany"
                            hide-no-data
                            placeholder="type 3 words to search..."
                            label="Company *"
                            item-text="name"
                            item-value="id"
                            required
                            return-object
                          >
                          </v-autocomplete>
                        </v-flex>
                        <v-flex
                            xs12
                            sm6
                            md4>
                          <v-text-field
                              v-model="editedItem.ext"
                              :rules="[rules.number, rules.max5chars]"
                              label="Ext"
                          />
                        </v-flex>
                        <v-flex
                            xs12
                            sm6
                            md4>
                          <v-text-field
                              v-model="editedItem.phone"
                              :rules="[rules.number,rules.max50chars]"
                              label="Phone No"/>
                        </v-flex>
                      </v-layout>
                    </v-container>
                  </v-card-text>

                  <v-card-actions>
                    <v-spacer/>
                    <v-btn
                      color="red darken-1"
                      flat
                      @click="close">Cancel
                    </v-btn>
                    <v-btn
                      :disabled="!valid"
                      color="green darken-1"
                      flat
                      @click="save">Save
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-form>
            </v-dialog>

            <v-btn
              :disabled="hasPermission('MA_MD_CUSTOMER_READ') === true"
              :dark="hasPermission('MA_MD_CUSTOMER_READ') === false"
              color="general"
              class="mb-2 ml-1 mr-1"
              @click="$refs.downloadExcel.generate()"
            >
              <download-excel
                ref="downloadExcel"
                :fetch="fetchData"
                :before-generate="beforeFetch"
                :fields="excelFields"
                class="btn btn-default"
                worksheet="worksheet"
                name="Customer-All.xls">
                <v-icon>mdi-file-excel</v-icon>
              </download-excel>&nbsp;Export All
            </v-btn>
            <v-btn
              :disabled="selectFileDisabled || hasPermission('MA_MD_CUSTOMER_READ') === true"
              :dark="hasPermission('MA_MD_CUSTOMER_READ') === false"
              class="mb-2 ml-1 mr-1"
              color="general"
              @click="$refs.inputUpload.click()">
              Select&nbsp;<v-icon>mdi-file-excel</v-icon>
            </v-btn>
            <input
              v-show="false"
              ref="inputUpload"
              type="file"
              @change="loadFile"
            >
            <v-chip
              v-show="showFilename"
              class="ma-1"
              color="general"
              label
              outline
            >
              <v-icon left>mdi-file-check</v-icon>
              {{ file.name }}
            </v-chip>
            <v-btn
              :loading="uploadFileLoading"
              :disabled="uploadFileDisabled"
              :dark="!uploadFileDisabled"
              color="general"
              class="mb-2 ml-1 mr-1"
              @click="uploadFile">Upload
              <v-icon>mdi-upload</v-icon>
            </v-btn>
            <v-progress-linear
              v-show="uploadFileLoading"
              :indeterminate="true"/>
            <v-dialog
              v-model="dialogDelete"
              max-width="400px">
              <v-card>
                <v-card-title class="headline">System Message Confirmation</v-card-title>
                <v-card-text>
                  Are you sure want to remove this data? <br>
                  "{{ deleteItemRecord.name }}"
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="red darken-1"
                    text
                    flat
                    @click="dialogDelete = false"
                  >
                    Cancel
                  </v-btn>
                  <v-btn
                    color="green darken-1"
                    text
                    flat
                    @click="deleteItem(deleteItemRecord)"
                  >
                    Ok
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-data-table
              :loading="loading"
              :headers="headers"
              :items="DataList"
              :pagination.sync="pagination"
              :rows-per-page-items="rowsAmount"
              :total-items="totalRows"
              dense
              loading-text="Loading... Please wait"
              class="elevation-1"
            >
              <!-- change table header background and text color(or other properties) -->
              <template
                slot="headerCell"
                slot-scope="{ header }"
              >
                <span
                  class="subheading font-weight-light text-general text--darken-3"
                  v-text="header.text"
                />
              </template>
              <template v-slot:items="props" >
                <td class="justify-center ">
                  <v-icon
                    medium
                    class="mr-2"
                    @click="editItem(props.item)">edit
                  </v-icon>
                  <v-icon
                    medium
                    @click="dialogDeleteShow(props.item)">delete
                  </v-icon>
                </td>
                <td>
                  {{ props.item.name }}
                </td>
                <td class="">{{ props.item.company.name }}</td>
                <td>
                  {{ props.item.email }}

                </td>
                <td class="">{{ props.item.phone }}</td>
                <td class="">{{ props.item.mobilePhone }}</td>
                <td class="">{{ props.item.position }}</td>
                <td class="">{{ props.item.lastUpdateBy }}</td>
                <td >{{ toStringDate(props.item.lastUpdateDate) }}</td>
              </template>
            </v-data-table>
            <v-snackbar
              v-model="snack"
              :timeout="5000"
              :color="snackColor">
              {{ snackText }}
              <v-btn
                flat
                @click="snack = false">Close
              </v-btn>
            </v-snackbar>
            <v-dialog
              v-model="dialogUploadFinish"
              scrollable
              persistent
              max-width="480px">
              <v-card>
                <v-card-title class="headline">Import Excel Information</v-card-title>
                <v-card-text>
                  <div
                    class="body-1"
                    style="white-space: pre;">{{ uploadResponse.errMessage }}</div>
                </v-card-text>
                <v-card-actions>
                  <v-spacer/>
                  <v-btn
                    color="green darken-1"
                    text
                    flat
                    @click="dialogUploadFinish = false"
                  >
                    OK
                  </v-btn>

                </v-card-actions>
              </v-card>
            </v-dialog>
          </material-card>
        </div>
      </v-flex>

    </v-layout>
  </v-container>
</template>

<script>
  import displayFormatterMixins from '../../../mixins/displayFormatterMixins'
  import {mapGetters} from 'vuex';

  export default {
    mixins: [displayFormatterMixins],
    data: () => ({
      snack: false,
      valid: false,
      lazy: false,
      snackColor: '',
      snackText: '',
      rules: {
        required: value => !!value || 'Required.',
        requiredCompany: value => {
          return !!value.id || 'Required'
        },
        max50chars: value => !value || value.length <= 50 || 'Max 50 characters',
        max5chars: value => !value || value.length <= 15 || 'Max 5 characters',
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return !value || pattern.test(value) || 'Invalid e-mail.'
        },
        number: value => !isNaN(value) || 'Must be numeric'
      },
      pagination: {},
      DataList: [],
      totalRows: 0,
      checkboxAdmin: true,
      checkboxActive: true,
      rowsAmount: [5, 20, 50, 100],
      dialog: false,
      dialogDelete: false,
      dialogUploadFinish: false,
      uploadResponse: {},
      deleteItemRecord: '',
      loading: true,
      loadingCompanies: false,
      searchCompany: '',
      search: '',
      headers: [
        { text: '--Actions--', value: 'actions', sortable: false },
        { text: 'Name', value: 'name' },
        { text: 'Company', value: 'company.name' },
        { text: 'Email', value: 'email' },
        { text: 'Telephone No', value: 'phone' },
        { text: 'Mobile Phone', value: 'mobilePhone' },
        { text: 'Position', value: 'position' },
        { text: 'Update By', value: 'lastUpdateBy' },
        { text: 'Update Date Time', value: 'lastUpdateDate' }
      ],
      excelFields: {
        'Name (*)': 'name',
        'Company (*)': 'company.name',
        'Email (*)': 'email',
        'Telp (*)': {
          callback: value => `="${value.phone}"`
        },
        'Mobile (*)': {
          callback: value => `="${value.mobilePhone}"`
        },
        'Position (*)': 'position',
        'Update By': 'lastUpdateBy',
        'Update Date Time': {
          callback: (value) => {
            return new Date(value.lastUpdateDate).toLocaleString('en-GB')
          }
        }
      },
      companies: [],
      editedIndex: -1,
      editedItem: {
        id: null,
        name: '',
        email: '',
        phone: '',
        mobilePhone: '',
        ext: '',
        position: '',
        company: {
          id: null,
          name: ''
        }
      },
      defaultItem: {
        id: null,
        name: '',
        email: '',
        phone: '',
        mobilePhone: '',
        ext: '',
        position: '',
        company: {
          id: null,
          name: ''
        },
        lastUpdateDate: '',
        lastUpdateBy: ''
      },
      file: {},
      selectFileDisabled: false,
      uploadFileDisabled: true,
      uploadFileLoading: false,
      showFilename: false
    }),
    computed: {
      ...mapGetters(['hasPermission']), // without modules
      formTitle () {
        return this.editedIndex === -1 ? 'New Item' : 'Edit Item'
      }
    },

    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination: {
        async handler () {
          console.debug('pagination watcher')
          this.getCustomers()
        }
      },
      search () {
        console.debug('search watcher')
        this.debouncedGetCustomers()
      },
      searchCompany () {
        console.debug('searchCompany watcher: ' + this.searchCompany)
        if (this.searchCompany && this.searchCompany.length >= 3) {
          this.debouncedGetCompanies()
        }
      }
    },
    // called when page is created before dom
    created () {
      // this.getCompanies()
      this.debouncedGetCustomers = _.debounce(this.getCustomers, 500)
      this.debouncedGetCompanies = _.debounce(this.getCompaniesPaging, 500)
    },

    methods: {
      async getCompaniesPaging () { // paging not yet implemented
        try {
          // const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.searchCompany == null ? '' : this.searchCompany
          // let pageNoXHR = page - 1
          // let response = await this.$http.get(`/api/company/select?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)
          let response = await this.$http.get(`api/company/autocomplete?ps=100&pn=0&so=name&q=${q}`)

          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },
      async getCustomers () {
        try {
          this.loading = true
          const { sortBy, descending, page, rowsPerPage } = this.pagination
          let q = this.search == null ? '' : this.search
          console.debug(this.pagination)
          let pageNoXHR = page - 1
          let response = await this.$http.get(`/api/customer?ps=${rowsPerPage}&pn=${pageNoXHR}&so=${sortBy}&dc=${descending}&q=${q}`)

          this.loading = false
          this.DataList = response.data.content
          this.totalRows = response.data.totalElements
        } catch (error) {
          console.log(error)
        }
      },
      async beforeFetch (e) {
        console.log('before fetch')
      },
      async fetchData () {
        const response = await this.$http.get(`/api/customer/all`)
        return response.data
      },
      showProgressBar () {
        this.uploadFileLoading = true
      },
      hideProgressBar () {
        this.uploadFileLoading = false
      },
      async getCompanies () {
        try {
          let response = await this.$http.get('/api/company/select')
          this.companies = response.data
        } catch (error) {
          console.log(error)
        }
      },

      // object.assign fills in the empty object with the properties of item
      editItem (item, dbox = true) {
        this.editedIndex = this.DataList.indexOf(item)
        item.isAdmin = this.checkboxAdmin
        item.isActive = this.checkboxActive
        this.editedItem = Object.assign({}, item)
        this.searchCompany = this.editedItem.company.name
        this.getCompaniesPaging()
        this.dialog = dbox
      },

      callTableAction (item, endpoint, method) {
        let tableItem = this.editedItem
        this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
          .then((response) => this.saveInline())
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
      },
      dialogDeleteShow (data) {
        this.dialogDelete = true
        this.deleteItemRecord = data
      },

      deleteItem (rec) {
        let endpoint = `api/customer/${rec.id}`
        let method = 'delete'
        let s = {}
        this.$store.dispatch('updateTableItem', { endpoint, s, method })
          .then((response) => {
            if (response.data.message == 'FAILED') {
              this.cancelInline(response.data.details)
              return
            } else {
              this.deleteInline()
              this.DataList.splice(this.DataList.indexOf(rec), 1)
            }
          })
          .catch(error => {
            console.log(error)
            this.cancelInline()
          })
        this.dialogDelete = false
      },

      close () {
        this.dialog = false
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem)
          this.editedIndex = -1
        }, 300)
      },

      save () {
        // if (!this.$refs.form.validate()) {
        //   console.log('validation fail direct')
        // }
        // if (this.$refs.form.validate()) {
        //   console.log('validation success')
        // }
        if (this.editedIndex > -1) {
          let tableItem = this.editedItem

          // let id = this.editedItem.company.id
          // this.editedItem.company.name = _.find(this.companies, { 'id': id }).name

          let endpoint = `api/customer/${this.editedItem.id}`
          let method = 'patch'
          let index = this.editedIndex
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
                if (response.data.message === 'FAILED') {
                  this.cancelInline(response.data.details)
                  return false
                } else {
                  Object.assign(this.DataList[index], response.data)
                  this.saveInline()
                }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        } else {
          let tableItem = this.editedItem
          let endpoint = `api/customer`
          let method = 'post'
          this.$store.dispatch('updateTableItem', { endpoint, tableItem, method })
            .then((response) => {
              if (response.data.message === 'FAILED') {
                this.cancelInline(response.data.details)
                return false
              } else {
                this.getCustomers()
                this.saveInline()
              }
            })
            .catch(error => {
              console.log(error)
              this.cancelInline()
            })
        }
        this.close()

      },
      async loadFile (e) {
        /** Load same file would not work!! @change event **/
          // const files = e.target.files
        const fileref = this.$refs.inputUpload.files
        console.debug(fileref.length)
        if (fileref[0] == undefined || fileref[0].type != 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') {
          this.fileFormatSnack()
          return
        }
        if (fileref[0] !== undefined) {
          console.debug(fileref[0].name)
          console.debug('Type: ' + fileref[0].type)
          console.debug('Size: ' + fileref[0].size + ' bytes')
          const fr = new FileReader()
          fr.readAsDataURL(fileref[0])
          fr.addEventListener('load', async () => {
            // console.debug(fr.result)
            // this.imageFile = files[0] // this is an image file that can be sent to server...
            // let response = await this.$store.dispatch('uploadFile', { file, endpoint })
            // console.debug(response)
            this.file = fileref[0]
            this.showFilename = true
            this.uploadFileDisabled = false
          })
        } else {
          this.file = {}
        }
      },
      async uploadFile () {
        let endpoint = 'api/excel/customer'
        let filexls = this.file
        console.debug(this.file)
        try {
          this.uploadFileLoading = true
          this.uploadFileDisabled = true
          this.selectFileDisabled = true
          let response = await this.$store.dispatch('uploadFile', { filexls, endpoint })
          if (response.data.message == 'FAILED') {
            this.uploadFileLoading = false
            this.uploadFileDisabled = false
            this.selectFileDisabled = false
            this.cancelInline(response.data.details)
            return
          }
          this.uploadResponse = response.data
          console.debug(this.uploadResponse)
          this.dialogUploadFinish = true
          this.getCustomers()
        } catch (error) {
          console.log(error)
          this.cancelInline()
        }
        this.showFilename = false
        this.uploadFileLoading = false
        this.selectFileDisabled = false
        this.file = {}
        this.$refs.inputUpload.value = '' // make sure it is free from file object
      },
      // toasts/snackbar messages for actions
      saveInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data saved/updated'
      },
      cancelInline (txt) {
        this.snack = true
        this.snackColor = 'error'
        this.snackText = txt || 'Canceled'
      },
      deleteInline () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data removed'
      },
      reset () {
        this.snack = true
        this.snackColor = 'success'
        this.snackText = 'Data reset to default'
      },
      openInline () {
        this.snack = true
        this.snackColor = 'info'
        this.snackText = 'Dialog opened'
      },
      closeInline () {
        console.debug('Dialog closed')
      }
    }
  }
</script>

<style>
  /* If Using SELECT-ALL
  table.v-table thead tr th{
    color: #2196f3 !important;
    font-size: medium;
  }
  tbody tr:nth-of-type(odd) {
    background-color: #2196f3
  }
  */

</style>
